var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('service-view',{attrs:{"pictures":_vm.pictures,"serviceTitle":_vm.serviceTitle,"electricalActive":'active',"serviceDescription":_vm.serviceDescription}})}
var staticRenderFns = []

export { render, staticRenderFns }